let forms = document.querySelectorAll(".logineko-login");

//Look for all the forms on the website
forms.forEach( ( form ) => {
    let loginButton = <HTMLInputElement>form.querySelector('.logineko-login__submit');
    let username    = <HTMLInputElement>form.querySelector('.logineko-login__input[name="username"]');
    let password    = <HTMLInputElement>form.querySelector('.logineko-login__input[name="password"]');
    
    // Triger login button inside the form
    loginButton?.addEventListener('click', (e)=>{
        if( username.value != "" && password.value != "" ) {
            e.preventDefault();
            loginekoLoginUser(e, form);
        }
    });
})

let loginekoLoginUser = (e, form) => {
    
    switchLoginButton(e, form, "loading");

    const ajaxData = (window as any).njamito_ajax;
    
    if ((window as any).njamito_ajax) {
        
        let data = new FormData(form);
        data.append("action", "njamito_user_login_action");
        
        fetch(ajaxData.ajax_url, {
            method: 'POST',
            body: data
          }).then(response => {
      
            return response.json();
      
          }).then(jsonResponse => {
      
            if ( ! jsonResponse.success ) {
                let messageBox = <HTMLParagraphElement>form.querySelector(".login-message");
                messageBox.innerHTML = jsonResponse.data.message;
                switchLoginButton(e, form, "ready");
            }
            
            if ( jsonResponse.success ) {
                window.location.href = jsonResponse.data.njamito_redirect;
            }
        });
    }
}

const switchLoginButton = (e, form, state) => {
    const styles = window.getComputedStyle(e.target);
    const backgroundColor = styles.getPropertyValue('background-color');
    const globals = window.getComputedStyle(document.documentElement);
    const color = globals.getPropertyValue('--login-button-dynamic-color');
    const preloader = form.querySelector(".loader-citrus")
    
    //Change button text color to button background color and turn on preloader
    if (state == "loading"){
        e.target.style.color = backgroundColor;
        e.target.style.pointerEvents = "none";
        preloader.style.display = "block";
    }

    //Turn off preloader and reverse button text
    if (state == "ready"){
        e.target.style.color = color;
        e.target.style.pointerEvents = "initial";
        preloader.style.display = "none";
    }
}
